import { render } from "./Contact.vue?vue&type=template&id=065fa6ab"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=065fa6ab&lang=css"

import exportComponent from "/builds/clients/stanovak/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__